exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".time-value[data-v-47c47816] {\n  display: inline-block;\n  width: 1.2em;\n  text-align: center;\n}\n.time-decimal[data-v-47c47816] {\n  margin-left: -0.4em;\n}\n", ""]);

// exports
